import Rails from '@rails/ujs';
Rails.start();

import { Chart, BarController, BarElement, CategoryScale, LinearScale, TimeScale, Colors, Tooltip } from 'chart.js';
import 'chartjs-adapter-luxon';

import 'datatables.net-dt';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-fixedheader-dt';

import ChartsModule from './javascripts/charts_module.js';

import './javascripts/adsense_fix.js';
import './javascripts/autocomplete.js';
import './javascripts/beneficial_ownership_view.js';
import './javascripts/charts.js';
import './javascripts/datatables.js';
import './javascripts/reporting_persons.js';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, TimeScale, Colors, Tooltip);
Chart.defaults.font.family = 'IBM Plex Sans';
window.Chart = Chart;
window.drawBarChart = ChartsModule.drawBarChart;
